import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@doddly/core';

@Component({
  selector: 'ly-sign-out',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sign-out.component.html',
  styleUrl: './sign-out.component.css',
})
export class SignOutComponent {
  constructor(private auth: AuthService) {
    this.auth.signOut();
  }
}
